import type {
  FetchTrendingResourcesQuery,
  FetchTrendingResourcesQueryVariables,
  LatestResourcesByThemeQuery,
  LatestResourcesByThemeQueryVariables,
  LatestResourcesByTypeQuery,
  LatestResourcesByTypeQueryVariables,
  ResourceHubPageQuery,
  ResourceHubPageQueryVariables,
  FetchAwarenessDaysResourcesQuery,
  FetchAwarenessDaysResourcesQueryVariables,
  ResourceEntity,
} from '@edwin-group/cj-graphql/generated/graphql';
import requestHandler from '../requestHandler';
import { initializeApollo } from '../lib/apollo-client';
import {
  QUERY_FETCH_LATEST_RESOURCES_BY_THEME,
  QUERY_FETCH_TRENDING_RESOURCES,
  QUERY_FETCH_LATEST_RESOURCES_BY_TYPEE,
  QUERY_FETCH_AWARENESS_DAYS_CALENDAR_RESOURCES,
  QUERY_FETCH_RESOURCE_HUB_PAGE,
} from '@edwin-group/cj-graphql';
import { getAuthentication } from '@/hooks/useAuthentication';

export const fetchResourceHubPage = async () => {
  const apolloClient = initializeApollo();
  const { data, error } = await requestHandler(
    apolloClient.query<ResourceHubPageQuery, ResourceHubPageQueryVariables>({
      query: QUERY_FETCH_RESOURCE_HUB_PAGE,
    }),
  );

  if (error) {
    console.error('Error fetching resource', error);
    return { page: null };
  }

  return {
    page: data?.resourceHubPage?.data?.attributes,
    resourceTypes: data?.resourceTypes,
  };
};

export const fetchLatestResourcesByType = async (type: string, size: number = 2) => {
  const apolloClient = initializeApollo();

  if (!type) return;
  const { data, error } = await requestHandler(
    apolloClient.query<LatestResourcesByTypeQuery, LatestResourcesByTypeQueryVariables>({
      query: QUERY_FETCH_LATEST_RESOURCES_BY_TYPEE,
      variables: {
        types: [type],
        limit: size,
        staffId: getAuthentication()?.user?.documentId || '',
      },
    }),
  );

  if (error) {
    console.error('Error fetching resource', error);
    return { resources: null };
  }

  return {
    resources: data?.resources?.data,
  };
};

export const fetchLatestResourcesBySubTrait = async (subTrait: string, size: number = 4, page?: number) => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<LatestResourcesByThemeQuery, LatestResourcesByThemeQueryVariables>({
      query: QUERY_FETCH_LATEST_RESOURCES_BY_THEME,
      variables: {
        subTrait,
        limit: size,
        page,
      },
    }),
  );

  if (error) {
    console.error('Error fetching resource', error);
    return { resources: null };
  }

  return {
    resources: data?.resources?.data,
    meta: data?.resources?.meta,
  };
};

export const fetchAwarenessDaysResources = async (size: number = 2) => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<FetchAwarenessDaysResourcesQuery, FetchAwarenessDaysResourcesQueryVariables>({
      query: QUERY_FETCH_AWARENESS_DAYS_CALENDAR_RESOURCES,
      variables: {
        limit: size,
      },
    }),
  );

  if (error) {
    console.error('Error fetching resource', error);
    return { resources: null };
  }

  return {
    resources: data?.awarenessDaysResources as ResourceEntity[],
  };
};

export const fetchTrendingResources = async (size: number = 3) => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<FetchTrendingResourcesQuery, FetchTrendingResourcesQueryVariables>({
      query: QUERY_FETCH_TRENDING_RESOURCES,
      variables: {
        limit: size,
      },
    }),
  );

  if (error) {
    console.error('Error fetching resource', error);
    return { resources: null };
  }

  return {
    resources: data?.trendingResources?.slice(0, size),
  };
};
